module.exports = __webpack_public_path__ + "img/group-invitation-code-sea.2457d8b9.png";